<template>
  <div>
    <b-container class="mt-4 mb-4">
      <div class="col-md-8 mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="$t('my.favorites.title')"/>
      </div>

      <transition-group v-if="isLoading" appear name="listCustomTransition" tag="div">
        <div key="homePlaceHolder-draft" class="mt-4">
          <div class="other-annonces card-container row row-cards-annonces">
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
            <PlaceholderCardAnnonce :isAnimated=true :isForHome=true :isGradient=false></PlaceholderCardAnnonce>
          </div>
        </div>
      </transition-group>

      <transition-group v-if="!isLoading" name="listCustomTransition">
        <template v-if="favorites.length > 0" >
          <div class="favorite-annonces cards-container" key="favorites-list">
            <annonce-card-image-left v-for="annonce in favorites" :key="annonce.serverId"
                                     :annonce="annonce"
                                     class="cursor-pointer" from-my-annonce/>
          </div>
        </template>
        <template v-else>
          <div class="card-container" key="favorites-empty-list">
            <div class="d-flex">
              <div class="p-3">
                <img :src="require(`@/assets/images/b122/img-confused.png`)" alt="no result"
                     class="empty-state-img-home">
              </div>
              <div class="empty-state-text">
                {{ $t('my.favorites.empty.state.description') }}
              </div>
            </div>
          </div>

        </template>
      </transition-group>
    </b-container>
  </div>
</template>


<script>
import api from '../../services/api'
import ShowActions from '../../components/b122/ShowActions.vue'
import BackArrow from '../../components/b122/BackArrow.vue'
import AnnonceCardImageLeft from "../../components/annonce/AnnonceCardImageLeft";
import AnnonceCardImageTop from "../../components/annonce/AnnonceCardImageTop";
import PlaceholderCardAnnonce from "../search/PlaceholderCardAnnonce";

export default {

  name: 'MyFavorites',
  components: {BackArrow, ShowActions, AnnonceCardImageLeft, PlaceholderCardAnnonce},

  data() {
    return {

      userId: this.$store.getters.userId,
      user: {},
      favorites: [],
      isLoading: true,
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    async fetchData() {
      await this.fetchMyFavorites()
    },

    async fetchMyFavorites() {
      api({
        method: "GET",
        url: '/annonce/getMyFavorites',
      })
        .then(async (response) => {
          this.favorites = response.data
          this.isLoading = false
        })
    },
  }
}
</script>

<style scoped>
.cards-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; /* Alignement des cartes à gauche */
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; /* Alignement des cartes à gauche */
  margin-right: -5px;
  margin-left: -5px;
}


.other-annonces .card-inside-container {
  margin-top: 0.5em;
  flex: 1 1 auto;
  min-width: 250px;
  width: 25%;
  max-width: 25%;
  padding-right: 5px;
  padding-left: 5px;
}

.favorite-annonces .card-inside-container {
  margin-top: 0.5em;
  flex: 1 0 auto;
  min-width: 300px;
  width: 25%;
  max-width: 25%;
  padding-right: 5px;
  padding-left: 5px;
}

.other-annonces .card {
  display: flex;
  align-items: center;
}


.empty-state-text {
  margin-top: 3.5rem;
  max-width: 300px;
}

.row-cards-annonces {
  margin-right: 0.5em;
  margin-top: 0.5em;
  margin-left: -0.5em;
}

@media (max-width: 768px) {

  .other-annonces .card-inside-container {
    width: 100% !important;
    max-width: 100% !important;
  }

  .favorite-annonces .card-inside-container {
    width: 100% !important;
    max-width: 100% !important;
  }

}

@media (max-width: 991px) {
  .other-annonces .card-inside-container {
    width: 50%;
    max-width: 50%;
  }

  .favorite-annonces .card-inside-container {
    width: 50%;
    max-width: 50%;
  }
}


</style>



// WEBPACK FOOTER //
// src/views/user/MyFavorites.vue